export enum ConditionTypes {
  Triggers = 'triggers',
  Matches = 'matches',
}
